import * as angular from "angular";

const contactTypes = [
  {text: 'SMS', permission: 'messages.sms.send'},
  {text: 'Email', permission: 'messages.email.send'}
]

angular
  .module('bringoz.admin.user')
  .constant('userConstants', {
    contactTypes: contactTypes
  });
